<script>
	import { getContext, createEventDispatcher } from "svelte";
	import { Popup } from "@xbs/svelte-wx";
	import { correctPopupPosition, locateID } from "@xbs/lib-dom";

	export let pos = {};
	export let event = {};
	export let calendars = [];
	const templates = getContext("schedulerTemplates");
	const dispatch = createEventDispatcher();
	let popup;
	$: if (popup) {
		pos = {
			...correctPopupPosition(pos, {
				width: popup.offsetWidth,
				height: popup.offsetHeight,
			}),
		};
	}
	$: calendar = calendars.find(type => type.id === event.type);
	function closeEventInfo(e) {
		const id = locateID(e);
		if (id == event.id) return;
		dispatch("action", {
			action: "close-event-info",
			data: {},
		});
	}

</script>

<Popup area={pos} cancel={closeEventInfo}>
	<div bind:this={popup}>
		<svelte:component this={templates.popup} {event} {calendar} on:action />
	</div>
</Popup>
